import axiosInstance from "./AuthContext";
import { useAuth } from "./AuthContext";


axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {

      const { setAccessToken, setRefreshToken, refreshToken, clear } = useAuth();
        
      originalRequest._retry = true; 
      try {
        
        // Refresh token
        const response = await axiosInstance.post('/accounts/token/refresh/', {
            refresh: refreshToken,
        });

        // Set new tokens
        const responseJson = await response.json()
        setAccessToken(responseJson.access)
        setRefreshToken(responseJson.refresh)

        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${responseJson.access}`;
        return axiosInstance(originalRequest);

      } catch (refreshError) {

        console.error('Token refresh failed:', refreshError);
        clear();
        window.location.href = '/signin';
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
